import React from "react";
import { PermissionsContext } from "contexts/permissionsContext";
import { AmountField } from "./components/AmountField";
import { PaymentChannelField } from "./components/PaymentChannelField";
import { UserField } from "./components/UserField";

export const RenderFields = ({showAmount, showPaymentChannel, showUser, applicatedFields, setApplicatedFields}) => {
    const { featureFlags } = React.useContext(PermissionsContext);

    return (
        <>
            {featureFlags.includes("filters_amount_field") &&
                showAmount && (
                    <AmountField
                        applicatedFields={applicatedFields}
                        setApplicatedFields={setApplicatedFields}
                    />
                )}
            {featureFlags.includes("filters_payment_channel_field") &&
                showPaymentChannel && (
                    <PaymentChannelField
                        applicatedFields={applicatedFields}
                        setApplicatedFields={setApplicatedFields}
                    />
                )}
            {featureFlags.includes("filters_user_field") &&
                showUser && (
                    <UserField
                        applicatedFields={applicatedFields}
                        setApplicatedFields={setApplicatedFields}
                    />
                )}
        </>
    );
};
